<template>
  <div>
    <v-row v-for="(row, rowIndex) in layout" :key="rowIndex">
      <v-col
        :cols="col.cols"
        :md="col.md"
        v-for="(col, colIndex) in row"
        :key="colIndex"
      >
        <RenderComponente
          v-for="(componente, compIndex) in col.componentes"
          :key="compIndex"
          :type="componente.tipo"
          :props="componente.props"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import RenderComponente from "./RenderComponente";
export default {
  name: "GenerarComponentes",
  props: {
    layout: {
      type: Array,
      required: true,
    },
  },
  components: {
    RenderComponente,
  },
};
</script>
